import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'

import styles from './styles.module.scss'
import { MENU_TABS } from '../../constants'
import { DEFAULT_ACTIVE_TAB_ID } from './constants'
import { useTabScrolling } from './hooks'

export const NavigationTabs = ({ onChangeActiveTab }) => {
  const history = useHistory()
  const [activeTab, setActiveTab] = useState(DEFAULT_ACTIVE_TAB_ID)
  const {
    wrapperRef,
    scrollToActiveTabWithDelay,
    scrollToActiveTabOnMount,
    registerTabRef,
  } = useTabScrolling()

  const changeActiveTab = (id, route) => {
    history.push(route)
    setActiveTab(id)
    onChangeActiveTab(id)

    // Scroll to active tab after a short delay to ensure DOM is updated
    scrollToActiveTabWithDelay(id)
  }

  const setActiveTabWhenChangingRoute = () => {
    const active = MENU_TABS?.find(
      el => el.route === history?.location?.pathname
    )

    if (active?.id !== activeTab || active?.id) {
      setActiveTab(active?.id)
      onChangeActiveTab(active?.id)

      // Scroll to active tab when route changes
      scrollToActiveTabWithDelay(active?.id)
    }
  }

  useEffect(() => {
    setActiveTabWhenChangingRoute()
  }, [history?.location?.pathname])

  // Scroll to active tab on component mount
  useEffect(() => {
    scrollToActiveTabOnMount(activeTab)
  }, [activeTab, scrollToActiveTabOnMount])

  return (
    <div
      className={styles.wrapper}
      ref={wrapperRef}
      data-testid='navigation-tabs'
    >
      {MENU_TABS?.map(el => (
        <div
          key={el.id}
          ref={ref => registerTabRef(el.id, ref)}
          onClick={() => changeActiveTab(el.id, el.route)}
          className={classNames(styles.tab, {
            [styles.active]: el.id === activeTab,
          })}
          data-testid={`nav-tab-${el.id}`}
        >
          <FormattedMessage id={el.title} />
        </div>
      ))}
    </div>
  )
}

export default NavigationTabs
